var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "box settings-block" },
      [
        _c(
          "md-card",
          { staticClass: "settings-block-space" },
          [
            _c("h2", { staticClass: "match-header" }, [_vm._v("SETTINGS")]),
            _vm._v(" "),
            _c("md-card-content", [
              _c(
                "form",
                {
                  attrs: { "data-vv-scope": "setting" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.save("setting")
                    }
                  }
                },
                [
                  _c("label", { staticClass: "card-header" }, [
                    _vm._v("Email Send Time")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-size-35" },
                        [
                          _c(
                            "md-field",
                            [
                              _c("label", { staticClass: "card-header" }, [
                                _vm._v("Timezone:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-select",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "timezone",
                                    placeholder: "time_zone"
                                  },
                                  model: {
                                    value: _vm.time_zone,
                                    callback: function($$v) {
                                      _vm.time_zone = $$v
                                    },
                                    expression: "time_zone"
                                  }
                                },
                                _vm._l(_vm.timeZoneList, function(
                                  timezone,
                                  index
                                ) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: timezone.value + index,
                                      attrs: { value: timezone.value }
                                    },
                                    [_vm._v(_vm._s(timezone.value))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "timepickerb-none" },
                    [
                      _c("vue-timepicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "Start", format: _vm.startFormat },
                        on: { input: _vm.inputHandler },
                        model: {
                          value: _vm.start_time,
                          callback: function($$v) {
                            _vm.start_time = $$v
                          },
                          expression: "start_time"
                        }
                      }),
                      _vm._v(" "),
                      _c("vue-timepicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          name: "End",
                          format: _vm.endFormat,
                          "hide-disabled-hours": "",
                          "hour-range": _vm.rangeDate
                        },
                        model: {
                          value: _vm.end_time,
                          callback: function($$v) {
                            _vm.end_time = $$v
                          },
                          expression: "end_time"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "md-checkbox",
                        {
                          staticClass: "m-left-5 card-header check-sendgrid",
                          model: {
                            value: _vm.mon,
                            callback: function($$v) {
                              _vm.mon = $$v
                            },
                            expression: "mon"
                          }
                        },
                        [_vm._v("Mon")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-checkbox",
                        {
                          staticClass: "m-left-5 card-header check-sendgrid",
                          model: {
                            value: _vm.tue,
                            callback: function($$v) {
                              _vm.tue = $$v
                            },
                            expression: "tue"
                          }
                        },
                        [_vm._v("Tue")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-checkbox",
                        {
                          staticClass: "m-left-5 card-header check-sendgrid",
                          model: {
                            value: _vm.wed,
                            callback: function($$v) {
                              _vm.wed = $$v
                            },
                            expression: "wed"
                          }
                        },
                        [_vm._v("Wed")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-checkbox",
                        {
                          staticClass: "m-left-5 card-header check-sendgrid",
                          model: {
                            value: _vm.thu,
                            callback: function($$v) {
                              _vm.thu = $$v
                            },
                            expression: "thu"
                          }
                        },
                        [_vm._v("Thu")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-checkbox",
                        {
                          staticClass: "m-left-5 card-header check-sendgrid",
                          model: {
                            value: _vm.fri,
                            callback: function($$v) {
                              _vm.fri = $$v
                            },
                            expression: "fri"
                          }
                        },
                        [_vm._v("Fri")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-checkbox",
                        {
                          staticClass: "m-left-5 card-header check-sendgrid",
                          model: {
                            value: _vm.sat,
                            callback: function($$v) {
                              _vm.sat = $$v
                            },
                            expression: "sat"
                          }
                        },
                        [_vm._v("Sat")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-checkbox",
                        {
                          staticClass: "m-left-5 card-header check-sendgrid",
                          model: {
                            value: _vm.sun,
                            callback: function($$v) {
                              _vm.sun = $$v
                            },
                            expression: "sun"
                          }
                        },
                        [_vm._v("Sun")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-raised md-round md-accent mt-20 ml-0",
                      attrs: { type: "submit" }
                    },
                    [_vm._v(_vm._s(_vm.saveText))]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "md-card",
          { staticClass: "settings-block-space mt-20" },
          [
            _c("h2", { staticClass: "match-header" }, [_vm._v("EVENT")]),
            _vm._v(" "),
            _c("md-card-content", [
              _c(
                "form",
                {
                  attrs: { "data-vv-scope": "event" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.saveEvent("event")
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            staticClass: "m-left-5 card-header check-sendgrid",
                            model: {
                              value: _vm.event.approvalByAdmin,
                              callback: function($$v) {
                                _vm.$set(_vm.event, "approvalByAdmin", $$v)
                              },
                              expression: "event.approvalByAdmin"
                            }
                          },
                          [_vm._v("Approvals by Administrators")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            staticClass: "m-left-5 card-header check-sendgrid",
                            model: {
                              value: _vm.event.tag,
                              callback: function($$v) {
                                _vm.$set(_vm.event, "tag", $$v)
                              },
                              expression: "event.tag"
                            }
                          },
                          [_vm._v("Add/Remove Tag")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            staticClass: "m-left-5 card-header check-sendgrid",
                            model: {
                              value: _vm.event.matchedAdviser,
                              callback: function($$v) {
                                _vm.$set(_vm.event, "matchedAdviser", $$v)
                              },
                              expression: "event.matchedAdviser"
                            }
                          },
                          [_vm._v("Match new adviser")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            staticClass: "m-left-5 card-header check-sendgrid",
                            model: {
                              value: _vm.event.sendRequestToAdviser,
                              callback: function($$v) {
                                _vm.$set(_vm.event, "sendRequestToAdviser", $$v)
                              },
                              expression: "event.sendRequestToAdviser"
                            }
                          },
                          [_vm._v("Send email to adviser (Send first email)")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            staticClass: "m-left-5 card-header check-sendgrid",
                            model: {
                              value: _vm.event.noRespondedAdvisor,
                              callback: function($$v) {
                                _vm.$set(_vm.event, "noRespondedAdvisor", $$v)
                              },
                              expression: "event.noRespondedAdvisor"
                            }
                          },
                          [_vm._v("Advisors that have not responded")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            staticClass: "m-left-5 card-header check-sendgrid",
                            model: {
                              value: _vm.event.snoozed,
                              callback: function($$v) {
                                _vm.$set(_vm.event, "snoozed", $$v)
                              },
                              expression: "event.snoozed"
                            }
                          },
                          [_vm._v("Snoozed")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            staticClass: "m-left-5 card-header check-sendgrid",
                            model: {
                              value: _vm.event.decline,
                              callback: function($$v) {
                                _vm.$set(_vm.event, "decline", $$v)
                              },
                              expression: "event.decline"
                            }
                          },
                          [_vm._v("Decline")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            staticClass: "m-left-5 card-header check-sendgrid",
                            model: {
                              value: _vm.event.thankYou,
                              callback: function($$v) {
                                _vm.$set(_vm.event, "thankYou", $$v)
                              },
                              expression: "event.thankYou"
                            }
                          },
                          [_vm._v("Thank You")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            staticClass: "m-left-5 card-header check-sendgrid",
                            model: {
                              value: _vm.event.closeRequest,
                              callback: function($$v) {
                                _vm.$set(_vm.event, "closeRequest", $$v)
                              },
                              expression: "event.closeRequest"
                            }
                          },
                          [_vm._v("Close request")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-raised md-round md-accent mt-20 ml-0",
                      attrs: { type: "submit" }
                    },
                    [_vm._v(_vm._s(_vm.saveEventBtn))]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "md-card",
          { staticClass: "settings-block-space mt-20" },
          [
            _c("h2", { staticClass: "match-header" }, [
              _vm._v("Block Domains")
            ]),
            _vm._v(" "),
            _c("md-card-content", [
              _c(
                "form",
                {
                  attrs: { "data-vv-scope": "event" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.saveBlockDomain("blockDomain")
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-field",
                          { staticClass: "mt--6" },
                          [
                            _c("md-textarea", {
                              attrs: {
                                name: "blockDomains",
                                placeholder: "Enter domains"
                              },
                              on: { input: _vm.sanitizeBlockDomains },
                              model: {
                                value: _vm.blockDomains,
                                callback: function($$v) {
                                  _vm.blockDomains = $$v
                                },
                                expression: "blockDomains"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "md-helper-text" }, [
                              _vm._v(
                                "Multiple domain must be comma(,) separated"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-raised md-round md-accent mt-20 ml-0",
                      attrs: { type: "submit" }
                    },
                    [_vm._v(_vm._s(_vm.saveDomain))]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "md-card",
          { staticClass: "settings-block-space mt-20" },
          [
            _c("h2", { staticClass: "match-header" }, [
              _vm._v("Block Email Addresses")
            ]),
            _vm._v(" "),
            _c("md-card-content", [
              _c(
                "form",
                {
                  attrs: { "data-vv-scope": "event" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.saveEmailAddress("emailAddress")
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "md-field",
                          { staticClass: "mt--6" },
                          [
                            _c("md-textarea", {
                              attrs: {
                                name: "blockEmailAddresses",
                                placeholder: "Enter email address"
                              },
                              on: { input: _vm.sanitizeBlockEmails },
                              model: {
                                value: _vm.blockEmailAddresses,
                                callback: function($$v) {
                                  _vm.blockEmailAddresses = $$v
                                },
                                expression: "blockEmailAddresses"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "md-helper-text" }, [
                              _vm._v(
                                "Multiple email must be comma(,) separated"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-raised md-round md-accent mt-20 ml-0",
                      attrs: { type: "submit" }
                    },
                    [_vm._v(_vm._s(_vm.saveEmail))]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "md-card",
          { staticClass: "settings-block-space mt-20" },
          [
            _c("h2", { staticClass: "match-header" }, [_vm._v("App Version")]),
            _vm._v(" "),
            _c("md-card-content", [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "md-field",
                      { staticClass: "mt--6" },
                      [
                        _c("md-textarea", {
                          attrs: {
                            name: "appVersion",
                            readonly: true,
                            placeholder: "App Version"
                          },
                          model: {
                            value: _vm.appVersion,
                            callback: function($$v) {
                              _vm.appVersion = $$v
                            },
                            expression: "appVersion"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "md-helper-text" }, [
                          _vm._v("Application version")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "md-card",
          { staticClass: "settings-block-space mt-20" },
          [
            _c("h2", { staticClass: "match-header" }, [
              _vm._v("Process Manager Dashboard")
            ]),
            _vm._v(" "),
            _c("md-card-content", [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-raised md-round md-accent mt-20 ml-0",
                        on: { click: _vm.redirectToProcessDashboard }
                      },
                      [
                        _vm._v(
                          "\n              Open Process Manager Dashboard\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47aa12d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47aa12d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = null
// module chunks = 